module.exports = __webpack_public_path__ + "img/u736.c124f234.svg";